import { memo } from "react";

import type { AnyObject } from "@similarweb/pro-logic-components";
import { Table } from "@similarweb/pro-logic-components";
import type { WithKey } from "@similarweb/pro-logic-components/dist/table/utils/types";

import { ROW_HOVER_CLASS_NAME } from "app/pages/benchmark-tracker/components/Report/MetricElements/TableView/constans";

import { NUMBER_OF_ELEMENTS } from "./config";
import { StyledTableContainer } from "./styles";
import type { TableViewEntity } from "./type";

const TableView = memo(
    ({
        tableData,
        columnsConfig,
        onRowHover,
        activeRowIndex,
        onMouseTableLeave,
        isLoading = false,
    }: TableViewEntity) => {
        const onRow = (_: WithKey<AnyObject>, index?: number) => {
            return {
                onMouseEnter: () => {
                    if (index != null) {
                        onRowHover?.(index);
                    }
                },
            };
        };

        const setRowClassName = (_: WithKey<AnyObject>, index?: number) =>
            index != null && index === activeRowIndex ? ROW_HOVER_CLASS_NAME : "";

        return (
            <StyledTableContainer onMouseLeave={onMouseTableLeave}>
                <Table
                    columnConfig={columnsConfig}
                    data={tableData}
                    onRow={onRow}
                    rowClassName={setRowClassName}
                    loaderRowCount={NUMBER_OF_ELEMENTS}
                    isLoading={isLoading}
                />
            </StyledTableContainer>
        );
    },
);
TableView.displayName = "TableView";

export default TableView;
